(function () {
  document.body.addEventListener('click', async function (e) {
    var sizeBox = e.target.closest('.product-sizes li');
    if (!sizeBox) return;

    var variantId = sizeBox.getAttribute('data-variant-id');
    if (!variantId) return;

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    var formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', Shopify.routes.root + 'variants/' + variantId);

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });

    if (response.ok) {
      var responseJson = await response.json();
      var cartContent = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      cartContent['sections'] = responseJson['sections'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer',
            cart: cartContent,
          },
        })
      );
    }
  });
})();
